import React from 'react';
import './styles.css';
import { RadioTile } from 'rsuite';

/**
 * Custom Panel component that applies the primary color of the custom theme to the checked state.
 * @component
 * @param {import('rsuite').RadioTileProps} rest - Additional props to pass to the Toggle component.
 * @returns {JSX.Element} CustomRadioTile component.
 */

export function CustomRadioTile({ children, ...rest }) {
  return (
    <RadioTile className="custom-radio-tile XXXXX" {...rest}>
      {children}
    </RadioTile>
  );
}
